import React from "react";
import BottomNav from "./BottomNav";

// Mobile-first shell that frames the whole app as a phone even on desktop.
export default function MobileShell({ children, nav = true }) {
  return (
    <div className="min-h-screen w-full bg-[#F3EDE6] flex justify-center">
      <div className="relative w-full max-w-md min-h-screen bg-background shadow-2xl overflow-hidden">
        <div className={nav ? "pb-28" : ""}>{children}</div>
        {nav && <BottomNav />}
      </div>
    </div>
  );
}
